<template>
  <div>
    <create-dialog
      @close="isNewTagOpened = false"
      @created="tagCreated"
      :makerId="makerId"
      :clientId="clientId"
      :default-label="searchString"
      v-if="isNewTagOpened"
    />
    <v-dialog
      v-model="dialog"
      width="350"
      scrollable
    >
      <v-card>
        <v-card-title>
          Tags
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0">
          <div class="pa-3">
            <v-text-field
              v-model="searchString"
              outlined
              solo
              flat
              hide-details
              autofocus
              prepend-inner-icon="search"
              placeholder="Chercher un tag"
            />
          </div>
          <v-list dense class="py-0">
            <div class="px-4 py-6" v-if="isFetchingTags">
              <v-progress-linear
                color="primary"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </div>
            <div class="pa-5 font-italic" v-else-if="!filteredTags.length">
              Aucun tag trouvé
            </div>
            <template v-for="(tag, i) in filteredTags">
              <v-list-item :disabled="!$canWrite" :key="tag.id" @click="$canWrite && (tagClicked(tag))">
                <v-list-item-avatar size="20" style="margin-top: 4px;">
                  <v-avatar :color="tag.color"></v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  {{ tag.label }}
                </v-list-item-content>
              </v-list-item>
              <v-divider :key="`divider-${tag.id}`" v-if="filteredTags.length > 1 && i < (filteredTags.length - 1)" />
            </template>
            <v-divider v-if="filteredTags.length" />
            <v-list-item :disabled="!$canWrite" @click="$canWrite && (isNewTagOpened = true)">
              <v-list-item-avatar size="20">
                <v-icon>add</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                Nouveau tag
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-chip
      color="grey"
      small
      outlined
      class="my-1 mx-1"
      @click="dialog = true"
    >
      <v-icon small left class="mr-1">add</v-icon>
      Ajouter un tag
    </v-chip>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import CreateDialog from '@/components/Tags/CreateDialog.vue';

export default {
  props: {
    clientId: {
      type: Number,
      required: false,
    },
    makerId: {
      type: Number,
      required: false,
    },
    excludedTags: {
      type: Array,
      required: false,
    },
  },

  data: () => ({
    dialog: false,
    isFetchingTags: false,
    searchString: ``,
    isNewTagOpened: false,
  }),

  computed: {
    ...mapState(`ui/tagsMenuList`, [
      `tags`,
    ]),
    flavoredTags() {
      return _.chain(this.tags)
        .map(tag => ({
          ...tag,
          $searchString: _.toLower(tag.label),
        }))
        .sortBy(`$searchString`)
        .value();
    },
    filteredTags() {
      const excludedTagsIds = _.map(this.excludedTags, `id`);
      let tags = _.filter(this.flavoredTags, tag => !_.includes(excludedTagsIds, tag.id));
      if (this.searchString && this.searchString.charAt(0) === `=`) {
        const searchString = this.searchString.slice(1);
        if (searchString.length) {
          tags = _.filter(tags, tag =>
            tag.$searchString.indexOf(searchString) === 0
          );
        }
      } else if (this.searchString) {
        this.searchString.split(` `).forEach(searchStringPart => {
          searchStringPart = _.toLower(searchStringPart);
          tags = _.filter(tags, tag =>
            tag.$searchString.indexOf(searchStringPart) !== -1
          );
        });
      }
      return tags;
    },
  },

  methods: {
    tagClicked(tag) {
      this.$emit(`selected`, tag);
    },
    tagCreated(tag) {
      this.searchString = ``;
      this.$emit(`selected`, tag);
    },
  },

  async beforeMount() {
    this.isFetchingTags = true;
    if (this.clientId) {
      await this.$store.dispatch(`ui/tagsMenuList/fetchClientTags`, this.clientId);
    } else if (this.makerId) {
      await this.$store.dispatch(`ui/tagsMenuList/fetchMakerTags`, this.makerId);
    }
    this.isFetchingTags = false;
  },

  components: {
    CreateDialog,
  },
};
</script>

<style lang="scss">
</style>
